import React, { useState } from "react";
import Chart from "react-apexcharts";
import Utils from "../../../../utils";

const ChartPolarAreaCustom = (props) => {

  // const { color, value, labelTooltip } = props;
  const { labels, series } = props;

  // const [series, setseries] = useState([50120.12, 20120.12, 80120.12]);

  const [optionsChart, setOptionsChart] = useState({
    labels: labels,
    chart: {
      selection: {
        enabled: false,
      },
      type: "polarArea",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    fill: {
      opacity: 0.8
    },
    stroke: {
      width: 2,
      colors: ['#fff']
    },
    yaxis: {
      show: true,
    },
    legend: {
      position: "bottom",
    },
    dataLabels: {
      // enabled: true,
    },
    yaxis: {
      labels: {
        formatter: (value) => { return Utils.numberWithCommas(value) },
      }
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 2,
        },
        spokes: {
          strokeWidth: 0,
        },
      },
    },
    // theme: {
    //   monochrome: {
    //     enabled: true,
    //     shadeTo: "light",
    //     shadeIntensity: 0.6,
    //   },
    // },
  });

  return (
    <Chart height="250px" options={optionsChart} series={series} type="polarArea"/>
  )
}

export default ChartPolarAreaCustom;